import { render, staticRenderFns } from "./MinPurchaseQuantity.vue?vue&type=template&id=3e8b000a&scoped=true&"
import script from "./MinPurchaseQuantity.vue?vue&type=script&lang=ts&"
export * from "./MinPurchaseQuantity.vue?vue&type=script&lang=ts&"
import style0 from "./MinPurchaseQuantity.vue?vue&type=style&index=0&id=3e8b000a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e8b000a",
  null
  
)

export default component.exports